import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Chip } from '../../model/chip.model';
import { StateService } from '@uirouter/core';

@Component({
    selector: 'app-url-param-chip-filter',
    templateUrl: './url-param-chip-filter.component.html',
    styleUrls: ['./url-param-chip-filter.component.scss']
})
export class UrlParamChipFilterComponent<T> implements OnInit, OnChanges {
    @Input() chips: Chip<T>[] = [];
    @Input() paramName: string = '';
    @Input() paramValue?: T;
    @Input() label?: string;

    public selectedIndex: number = -1;

    constructor(private stateService: StateService) { }

    ngOnInit(): void {
        this.setIndicies(this.paramValue, this.chips);
    }

    ngOnChanges(changes: SimpleChanges): void {
        const paramValue = changes['paramValue']?.currentValue;
        const chips = changes['chips']?.currentValue;

        if (paramValue !== undefined || chips !== undefined) {
            this.setIndicies(paramValue ?? this.paramValue, chips ?? this.chips);
        }
    }

    setIndicies(paramValue?: T, chips: Chip<T>[] = []) {
        this.selectedIndex = chips.findIndex(c => c.Value === paramValue);
    }

    onClick(chip: Chip<T> | null) {
        if (chip?.Value !== null && chip?.Value !== undefined) {
            const params = {};
            params[this.paramName] = chip.Value;
            this.stateService.go('.', params)
        }
    }
}
